import React, { useState } from "react";
import { Col, ListGroup, Row, Button, Container } from "react-bootstrap";
import { FormattedMessage } from "react-intl";

import IndicatorDelegation from "./sections/sectionsIndicatorsCandidatures/IndicatorDelegation.js";
import IndicatorCAE from "./sections/sectionsIndicatorsCandidatures/IndicatorCAE.js";
import IndicatorStatus from "./sections/sectionsIndicatorsCandidatures/IndicatorStatus.js";
import IndicatorRepresentativeData from "./sections/sectionsIndicatorsCandidatures/IndicatorRepresentativeData.js";
import IndicatorAdministrativeDivision from "./sections/sectionsIndicatorsCandidatures/IndicatorAdministrativeDivision.js";
import IndicatorApplicationChanges from "./sections/sectionsIndicatorsCandidatures/IndicatorApplicationChanges.js";
import IndicatorNonCompliance from "./sections/sectionsIndicatorsCandidatures/IndicatorNonCompliance.js";
import IndicatorPayments from "./sections/sectionsIndicatorsCandidatures/IndicatorPayments.js";

import ExportLoadingModal from "./sections/utils/ExportLoadingModal";

import ExportDialog from "./sections/utils/ExportDialog";
import { exportAllExcelsZip } from "./sections/utils/exportAllCandidaturesPages.js";

const INDICATOR_SECTIONS = [
  { id: "delegacao", label: "Delegação Regional" },
  { id: "cae", label: "CAE" },
  { id: "estado", label: "Estado" },
  { id: "dados", label: "Dados do Representante" },
  { id: "divisao", label: "Divisão Administrativa" },
  { id: "alteracoes", label: "Alterações à Candidatura" },
  { id: "incumprimentos", label: "Incumprimentos" },
  { id: "pagamentos", label: "Pagamentos" },
];

export default function IndicatorsCandidaturesPage() {
  const [activeSection, setActiveSection] = useState("delegacao");
  const [showExportAll, setShowExportAll] = useState(false);

  const [exporting, setExporting] = useState(false);
  const [zipPct, setZipPct] = useState(null);
  const [subtitleId, setSubtitleId] = useState(
    "indicator.exportar.todos.modal.preparing"
  );
  const [subtitleValues, setSubtitleValues] = useState(undefined);

  const renderActiveSection = () => {
    switch (activeSection) {
      case "delegacao":
        return <IndicatorDelegation />;
      case "cae":
        return <IndicatorCAE />;
      case "estado":
        return <IndicatorStatus />;
      case "dados":
        return <IndicatorRepresentativeData />;
      case "divisao":
        return <IndicatorAdministrativeDivision />;
      case "alteracoes":
        return <IndicatorApplicationChanges />;
      case "incumprimentos":
        return <IndicatorNonCompliance />;
      case "pagamentos":
        return <IndicatorPayments />;
      default:
        return null;
    }
  };

  const handleExport = () => setShowExportAll(true);

  const runWithLoading = async (fn) => {
    setExporting(true);
    setZipPct(null);
    setSubtitleId("indicator.exportar.todos.modal.preparing");
    setSubtitleValues(undefined);
    try {
      await fn({
        onZipProgress: (p) => {
          setZipPct(p);
          setSubtitleId("indicator.exportar.todos.modal.zipping");
          setSubtitleValues(undefined);
        },
      });
    } finally {
      setExporting(false);
      setZipPct(null);
      setSubtitleId("indicator.exportar.todos.modal.preparing");
      setSubtitleValues(undefined);
    }
  };

  return (
    <Container className="pb-5">
      <div className="mx-3 my-4">
        <Row className="align-items-center mb-4">
          <Col md={{ span: 8, offset: 2 }}>
            <h3 className="mb-0">
              <FormattedMessage id="indicators.work.progress.title" />
            </h3>
          </Col>
          <Col md={2} className="text-end">
            <Button
              variant="outline-primary"
              onClick={handleExport}
              style={{ fontSize: "1rem", padding: "0.6rem 1.2rem" }}
            >
              <FormattedMessage id="indicators.export" />
            </Button>
          </Col>
        </Row>

        <Row>
          <Col md={2}>
            <ListGroup variant="flush" className="border-0">
              {INDICATOR_SECTIONS.map((section) => {
                const isActive = activeSection === section.id;
                return (
                  <ListGroup.Item
                    key={section.id}
                    action
                    onClick={() => setActiveSection(section.id)}
                    className={`indicator-tab ${isActive ? "active-tab" : ""}`}
                  >
                    <FormattedMessage
                      id={`indicator.menu.${section.id}`}
                      defaultMessage={section.label}
                    />
                  </ListGroup.Item>
                );
              })}
            </ListGroup>
          </Col>
          <Col md={10}>
            <div
              className="p-3"
              style={{
                border: "1px solid #dee2e6",
                borderRadius: "4px",
                backgroundColor: "white",
              }}
            >
              {renderActiveSection()}
            </div>
          </Col>
        </Row>

        <ExportDialog
          show={showExportAll}
          onHide={() => setShowExportAll(false)}
          options={[
            {
              onClick: async () => {
                try {
                  await runWithLoading((progress) =>
                    exportAllExcelsZip(
                      "indicadores_projetos_em_curso_excels.zip",
                      progress
                    )
                  );
                  setShowExportAll(false);
                } catch (e) {
                  console.error("[Export All Excels] falhou:", e);
                  alert("Falha ao gerar ZIP com Excels: " + (e?.message || e));
                }
              },
              filename: "indicadores_projetos_em_curso_excels.zip",
              zipInnerType: "xlsx",
            },
          ]}
        />

        <ExportLoadingModal
          show={exporting}
          titleId="indicator.exportar.todos.modal.title"
          titleDefault="A gerar ZIP de indicadores...."
          subtitleId={subtitleId}
          subtitleDefault="A preparar ficheiros..."
          subtitleValues={subtitleValues}
          percent={zipPct}
          size="sm"
        />
      </div>
    </Container>
  );
}
